import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PageService } from '../../page/services/page.service';
import jwtDecode from 'jwt-decode';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  user: FormGroup;
  messageError: string;
  fieldTextType: boolean;
  fieldTextType2: boolean;
  spinner: boolean;
  token: string;
  tokenInfo: any;
  show: boolean;
  validate: boolean;

  constructor(
    private fb: FormBuilder,
    private authService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PageService
  ) {
    this.token = this.route.snapshot.queryParamMap.get('token');
    sessionStorage.setItem('token', this.token);
    this.crearFormulario();
  }

  ngOnInit(): void {
    if (this.token) {
      this.show = true;
      this.pageService.verifyFileToken(this.token).subscribe(
        (resp) => {
          this.validate = true;
          this.decodeJWT();
        },
        (error) => {
          console.log('ERROR', error);
          this.validate = false;
        }
      );
    } else {
      this.show = false;
    }
  }

  get pass1NoValido(): any {
    return (
      this.user.get('password').invalid && this.user.get('password').touched
    );
  }

  get pass2NoValido(): any {
    const pass1 = this.user.get('password').value;
    const pass2 = this.user.get('password2').value;
    return pass1 !== pass2;
  }

  decodeJWT(): void {
    this.tokenInfo = jwtDecode(this.token);
    console.log(this.tokenInfo);
  }

  crearFormulario(): any {
    this.user = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          /*Contraseña: Mínimo 8 caracteres, al menos una letra mayúscula, una letra minúscula y un número
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[ !@#$%^&*_=+-]).{8,}$')*/
        ],
      ],
      password2: ['', Validators.required],
    });
  }

  guardar(): any {
    if (this.user.invalid) {
      return Object.values(this.user.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((ctrl) =>
            ctrl.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }

    this.spinner = true;

    delete this.user.value.pass2;
    this.authService
      .updatePassword(this.tokenInfo.username, this.user.value.password2)
      .subscribe(
        (datas) => {
          if (datas) {
            Swal.close();
            this.login();
          }
        },
        (error) => {
          console.log(error);
          Swal.fire('', 'Hubo un error', 'warning');
        }
      );
  }

  toggleFieldTextType(): any {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleFieldTextType2(): any {
    this.fieldTextType2 = !this.fieldTextType2;
  }

  login(): void {
    console.log(this.user);

    this.authService
      .login(this.tokenInfo.username, this.user.value.password2)
      .subscribe(
        (resp) => {
          console.log(resp);
          if (resp.token) {
            sessionStorage.setItem('token', resp.token);
            sessionStorage.setItem('email', resp.usuarioWeb);
            switch (resp.rol) {
              case 'GRUPO':
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem('name', resp.name);
                const apellidosList: string[] = [];
                const nifColaboradoresList: string[] = [];
                const codigoColaboradoresList: string[] = [];
                for (const colaborador of resp.colaboradores) {
                  apellidosList.push(colaborador.apellido1);
                  nifColaboradoresList.push(colaborador.nif);
                  codigoColaboradoresList.push(colaborador.codigo);
                }
                console.log(apellidosList);
                console.log(nifColaboradoresList);
                console.log(codigoColaboradoresList);
                sessionStorage.setItem(
                  'colaboradores',
                  JSON.stringify(apellidosList)
                );
                sessionStorage.setItem(
                  'nifColaboradores',
                  JSON.stringify(nifColaboradoresList)
                );
                sessionStorage.setItem(
                  'codigoColaboradores',
                  JSON.stringify(codigoColaboradoresList)
                );
                break;
              default:
                sessionStorage.setItem('nifColaborador', resp.colaborador.nif);
                sessionStorage.setItem(
                  'codigoColaborador',
                  resp.colaborador.codigo
                );
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem(
                  'colaborador',
                  resp.colaborador.apellido1
                );
                break;
            }
            if (resp.rol === 'ROLE_SUPERADMIN') {
              this.router.navigateByUrl('/page/gestion', { replaceUrl: true });
            } else {
              this.router.navigateByUrl('/page/home', { replaceUrl: true });
            }
          }
        },
        (err) => {
          console.log(err);
          this.spinner = false;
          Swal.fire(
            'LOGIN INCORRECTO',
            'Introduce un usuario/contraseña válido',
            'warning'
          );
        }
      );

    /*this.authService
      .login(sessionStorage.getItem('email'), this.user.value.password)
      .subscribe(
        (resp) => {
          console.log(resp);
          if (resp.token) {
            sessionStorage.setItem('token', resp.token);
            sessionStorage.setItem('email', resp.usuarioWeb);
            switch (resp.rol) {
              case 'GRUPO':
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem('name', resp.name);
                const apellidosList: string[] = [];
                for (const colaborador of resp.colaboradores) {
                  apellidosList.push(colaborador.apellido1);
                }
                console.log(apellidosList);
                sessionStorage.setItem(
                  'colaboradores',
                  JSON.stringify(apellidosList)
                );
                break;
              default:
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem(
                  'colaborador',
                  resp.colaborador.apellido1
                );
                break;
            }
            if (resp.rol === 'ROLE_SUPERADMIN') {
              this.router.navigateByUrl('/page/gestion', { replaceUrl: true });
            } else {
              this.router.navigateByUrl('/page/home', { replaceUrl: true });
            }
          }
        },
        (err) => {
          console.log(err);
          this.spinner = false;
        }
      );*/
  }
}
